import { useEffect, useState } from 'react';
import { getGame } from '@/game';
import { useSettingsStore } from '@/state/settingsStore';

export function FpsIndicator() {
  const [fps, setFps] = useState(0);
  const visible = useSettingsStore((s) => s.showFps);

  useEffect(() => {
    if (!visible) return;
    let raf = 0;
    let last = performance.now();
    const tick = () => {
      const now = performance.now();
      if (now - last >= 500) {
        const game = getGame();
        const value = game?.loop?.actualFps ?? 0;
        setFps(Math.round(value));
        last = now;
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [visible]);

  if (!visible) return null;

  const color = fps >= 50 ? '#7CFC9A' : fps >= 30 ? '#ffd166' : '#ff6b6b';

  return (
    <div style={{
      position: 'fixed',
      top: 50,
      right: 8,
      padding: '4px 8px',
      background: 'rgba(0,0,0,0.75)',
      border: '1px solid #2c3e50',
      borderRadius: 4,
      color,
      fontFamily: 'monospace',
      fontSize: 12,
      fontWeight: 700,
      pointerEvents: 'none',
      zIndex: 99999,
    }}>
      {fps} FPS
    </div>
  );
}
